<template>
  <div id="nav">
    <component
      v-if="this.$route.meta.leftNavComponent"
      :is="this.$route.meta.leftNavComponent"
    />
    <router-link v-else class="nav__link" to="/">Recepten</router-link>
    <a href="#" class="nav__link" @click="logout">Uitloggen</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuOpen: false,
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("accessToken");
      this.$router.push("login");
    },
  },
};
</script>
